import React, { useEffect, useState } from "react";
import { Container, Dropdown, Tab, Tabs } from "react-bootstrap";
import OperationsAnalysis from "./operationsanalysis.js";
import OperationsAssessment from "./operationsassessment.js";
import OperationsActions from "./operationsaction.js";


const Operationsindex = () => {
    const [tabs] = useState([
        { id: 1, sub_category: 'Operations Analysis' },
        { id: 2, sub_category: 'Operations Assessment' },
        { id: 3, sub_category: 'Operations Actions' },
    ]);

    const [activeTab, setActiveTab] = useState('Operations Analysis');
    const [isMobile, setIsMobile] = useState(false);

    // Function to handle tab selection
    const handleTabSelect = (key) => {
        setActiveTab(key); // Update active tab state
    };

    // Function to render tab content based on selected tab
    const getTabContent = (tabName, activeTab) => {
        switch (tabName) {
            case 'Operations Analysis':
                return <OperationsAnalysis activeTab={activeTab} />;
            case 'Operations Assessment':
                return <OperationsAssessment activeTab={activeTab} />;
            case 'Operations Actions':
                return <OperationsActions activeTab={activeTab} />;
            default:
                return null;
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Set breakpoint for mobile screens
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <Container fluid>
            {isMobile ? (
                <>
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            {activeTab}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {tabs.map((tab) => (
                                <Dropdown.Item
                                    key={tab.id}
                                    onClick={() => handleTabSelect(tab.sub_category)}
                                >
                                    {tab.sub_category}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                    {getTabContent(activeTab)} {/* Render only once for mobile */}
                </>
            ) : (
                <Tabs
                    activeKey={activeTab}
                    onSelect={handleTabSelect}
                    id="justify-tab-example"
                    className="border-tab nav-primary mb-3"
                >
                    {tabs.map(tab => (
                        <Tab key={tab.id} eventKey={tab.sub_category} title={tab.sub_category}>
                            {getTabContent(tab.sub_category)} {/* Render content inside the Tabs */}
                        </Tab>
                    ))}
                </Tabs>
            )}
        </Container>
    );
};

export default Operationsindex;
